import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  CircularProgress,
  Paper,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ConnectionRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const navigate = useNavigate();

  const fetchRequests = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(
        "https://api.egosaferelationship.com/admin/connections",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      setRequests(data);
    } catch (err) {
      console.error("Failed to fetch connection requests:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleSort = (key) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === "asc";
    setSortConfig({ key, direction: isAsc ? "desc" : "asc" });
  };

  const sortedRequests = [...requests].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const valA = a[sortConfig.key]?.toString().toLowerCase();
    const valB = b[sortConfig.key]?.toString().toLowerCase();
    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <Box p={3} component={Paper} elevation={2}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Button variant="contained" onClick={() => navigate("/users")}>
          User Management
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/")}
        >
          Logout
        </Button>
      </Box>

      <Typography variant="h5" gutterBottom>
        Connection Requests
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>CR ID</TableCell>
              <TableCell>CR Type</TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortConfig.key === "requester_first_name"}
                  direction={sortConfig.direction}
                  onClick={() => handleSort("requester_first_name")}
                >
                  Requester
                </TableSortLabel>
              </TableCell>
              <TableCell>Status</TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortConfig.key === "status_date"}
                  direction={sortConfig.direction}
                  onClick={() => handleSort("status_date")}
                >
                  Last Status Date
                </TableSortLabel>
              </TableCell>
              <TableCell>Recipient</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRequests.map((req) => (
              <TableRow key={req.connection_id}>
                <TableCell>{req.connection_id}</TableCell>
                <TableCell>{req.connection_type}</TableCell>
                <TableCell>
                  {req.requester_first_name} {req.requester_last_name}
                </TableCell>
                <TableCell>{req.status}</TableCell>
                <TableCell>
                  {req.status_date
                    ? new Date(req.status_date).toLocaleDateString()
                    : "-"}
                </TableCell>
                <TableCell>
                  {req.recipient_first_name
                    ? `${req.recipient_first_name} ${req.recipient_last_name}`
                    : "N/A"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default ConnectionRequests;
